import React, { useEffect, useState } from "react";
import di from "../di/servicelocator";
import "../../../../stylesheets/components/Reports/HoldingReports/MobFilterAssetDrop.scss";
import EdButton from "../../../generic/edbutton/edButton";
import { FilterTabEnum } from "@frameworks/web/components/Reports/CommonComponent/constant";
const MobFilterAssetDrop = ({ setshowFilterAssetDropdown, filterData, setFilterData, fullSize, labeltext, showAsset, keyTab, }) => {
    var _a, _b, _c, _d;
    const [selectedFilters, setselectedFilters] = useState(filterData.simpleFilter.filters.filter((x) => x.selected).length);
    const [selectedAssetFilters, setselectedAssetFilters] = useState(filterData.assetFilter.filters.filter((x) => x.selected).length);
    const { simpleFilter, assetFilter, productAssetFilter } = filterData;
    const [tempfilterData, setTempFilterData] = useState(null);
    const handleChange = (eventKey, checked, filterType, setFilterCount) => {
        let { name, filters } = tempfilterData[filterType];
        filters = filters.map((filter) => {
            if (filter.key === eventKey)
                return Object.assign(Object.assign({}, filter), { selected: checked });
            return filter;
        });
        setFilterCount(filters.filter((x) => x.selected).length);
        setTempFilterData(Object.assign(Object.assign({}, tempfilterData), { [filterType]: { name, filters } }));
    };
    const applyFilter = async () => {
        let selectedAssetCategories = tempfilterData.assetFilter.filters.reduce((assetCategories, asset) => {
            if (asset.selected)
                assetCategories.push(asset.key);
            return assetCategories;
        }, []);
        if (selectedAssetCategories.length > 0 && keyTab === FilterTabEnum.ALL)
            sessionStorage.setItem("assetFilter", JSON.stringify(selectedAssetCategories));
        setFilterData === null || setFilterData === void 0 ? void 0 : setFilterData(tempfilterData);
        di.holdingReport.getFilteredHoldingReportData(tempfilterData);
        setshowFilterAssetDropdown(false);
    };
    const clearAllFilter = async () => {
        const defaultFilter = simpleFilter.filters.map((filter) => {
            if (filter.selected) {
                filter.selected = false;
            }
            return filter;
        });
        const defaultAssetFilter = assetFilter.filters.map((filter) => {
            if (filter.selected) {
                filter.selected = false;
            }
            return filter;
        });
        const defaultProductAssetFilter = productAssetFilter.filters.map((filter) => {
            if (filter.selected) {
                filter.selected = false;
            }
            return filter;
        });
        setselectedFilters(0);
        setselectedAssetFilters(0);
        sessionStorage.removeItem("assetFilter");
        di.holdingReport.getFilteredHoldingReportData({
            simpleFilter: { name: "Filter By", filters: defaultFilter },
            assetFilter: { name: "Asset filter", filters: defaultAssetFilter },
            productAssetFilter: {
                name: productAssetFilter.name,
                filters: defaultProductAssetFilter,
            },
        });
        setshowFilterAssetDropdown(false);
    };
    useEffect(() => {
        setTempFilterData(filterData);
    }, []);
    return (React.createElement("div", { className: "mob-filterasset-drop", style: { height: fullSize ? "700px" : "" } },
        React.createElement("div", { className: "mob-filterasset-drop-head" },
            React.createElement("div", { className: "down-bar" },
                React.createElement("span", { className: "down-bar-left" }, "Filters"),
                React.createElement("input", { onClick: clearAllFilter, className: "down-bar-right", type: "button", value: "Clear All" }))),
        React.createElement("div", { className: "mob-filterasset-drop-body" },
            labeltext ? (React.createElement("p", { className: "bodyhead" }, " Scrip Filter")) : (React.createElement("p", { className: "bodyhead" }, "Filters by")),
            React.createElement("ul", { className: "bodylist", id: "filter" }, (_b = (_a = tempfilterData === null || tempfilterData === void 0 ? void 0 : tempfilterData.simpleFilter) === null || _a === void 0 ? void 0 : _a.filters) === null || _b === void 0 ? void 0 : _b.map((val, idx) => {
                return (React.createElement("li", { key: idx },
                    React.createElement("label", { className: "checkbox" },
                        React.createElement("input", { type: "checkbox", checked: val.selected, value: val.key, onChange: (e) => handleChange(e.target.value, e.target.checked, "simpleFilter", setselectedFilters) }),
                        React.createElement("span", { className: "checked edel-icon-tick" }),
                        React.createElement("p", { className: "bodylist-title" }, val.title))));
            })),
            showAsset && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "filter-asset-seperator" }),
                React.createElement("p", { className: "bodyhead" }, "Asset Filters"),
                React.createElement("ul", { className: "bodylist", id: "asset" }, (_d = (_c = tempfilterData === null || tempfilterData === void 0 ? void 0 : tempfilterData.assetFilter) === null || _c === void 0 ? void 0 : _c.filters) === null || _d === void 0 ? void 0 : _d.map((val, idx) => {
                    return (React.createElement("li", { key: idx },
                        React.createElement("label", { className: "checkbox" },
                            React.createElement("input", { type: "checkbox", checked: val.selected, value: val.key, onChange: (e) => handleChange(e.target.value, e.target.checked, "assetFilter", setselectedAssetFilters) }),
                            React.createElement("span", { className: "checked edel-icon-tick" }),
                            React.createElement("p", { className: "bodylist-title" }, val.title))));
                }))))),
        React.createElement("div", { className: "mob-filterasset-drop-footer" },
            React.createElement(EdButton, { className: "apply_filter", value: "Apply Filters", onClick: applyFilter, disabled: !(selectedFilters > 0 || selectedAssetFilters > 0), btnTyp: "blue-one" }))));
};
export default MobFilterAssetDrop;
